import {useEffect} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import {pathnames as P} from 'common/constants/pathnames';

const GuestGuard = ({children}) => {
  const history = useHistory();
  const location = useLocation();
  const accessToken = useSelector(state => state.auth.accessToken, shallowEqual);
  const user = useSelector(state => state.user.user, shallowEqual);
  const isAuthorized = Boolean(accessToken) && Boolean(user);


  useEffect(() => {
    if (isAuthorized) {
      history.replace(location?.state?.from ? location?.state?.from : P.MAIN_MENU, {from: ''})
    }
  }, [isAuthorized, history, location]);

  return children;
};

export default GuestGuard;